import { render } from "./indextenpatient.vue?vue&type=template&id=e09ab00c"
import script from "./indextenpatient.vue?vue&type=script&lang=js"
export * from "./indextenpatient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__